export const OfficeFlexjobsCreateState = {
	url: '/flexjob/create',
	title: 'Office Create Flexjob',
	template: '<create-flexjob-page></create-flexjob-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFlexjobsCreatePageMod" */
			'@Containers/office-flexjobs-page/create/office-flexjobs-create.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
